import { FC } from 'react';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';
import { getDataFromBeneficiary } from '../utils/getDataFromBeneficiary';
import getPriceByPlan from '../utils/getPriceByPlan';

type TableRowProps = {
  index: number;
  beneficiaryData: any;
};

const PlanTableRow: FC<TableRowProps> = ({ index, beneficiaryData }) => {
  const { data } = useBeneficiarySellModal();

  const {
    planName,
    cliff,
    vestingPeriod,
    sharePrice,
    sharesCountFuture,
    beneficiaryUnits,
    soldUnits,
  } = getDataFromBeneficiary(beneficiaryData);

  const resultPrice = getPriceByPlan(
    beneficiaryData,
    data.unitsPrice,
    data.includeBeneficiaryNotVestedUnits
  );

  return (
    <>
      <td className="text-center">{index + 1}</td>
      <td className="text-left w-min-150px">{planName}</td>
      <td className="text-center">{cliff}</td>
      <td className="text-center">{vestingPeriod}</td>
      <td className="text-right">{formatNumber(sharesCountFuture)}</td>
      <td className="text-right">{formatNumber(beneficiaryUnits)}</td>
      <td className="text-right">{formatNumber(soldUnits)}</td>
      <td className="text-right">{formatCurrencyDecimals(sharePrice)}</td>
      <td className="text-right">{formatCurrencyDecimals(data.unitsPrice)}</td>
      <td className="text-right">
        {formatCurrencyDecimals(resultPrice)}
        <sup>&nbsp;</sup>
      </td>
    </>
  );
};

export default PlanTableRow;
